import { render, staticRenderFns } from "./deliveryEffiRider.vue?vue&type=template&id=bbcae23e&scoped=true"
import script from "./deliveryEffiRider.vue?vue&type=script&lang=js"
export * from "./deliveryEffiRider.vue?vue&type=script&lang=js"
import style0 from "./deliveryEffiRider.vue?vue&type=style&index=0&id=bbcae23e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbcae23e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\space\\tops\\tops-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bbcae23e')) {
      api.createRecord('bbcae23e', component.options)
    } else {
      api.reload('bbcae23e', component.options)
    }
    module.hot.accept("./deliveryEffiRider.vue?vue&type=template&id=bbcae23e&scoped=true", function () {
      api.rerender('bbcae23e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/delivery/deliveryEffiRider.vue"
export default component.exports